"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var avatar_st_css_1 = require("./avatar/avatar.st.css");
var button_st_css_1 = require("./button/button.st.css");
var icon_button_st_css_1 = require("./icon-button/icon-button.st.css");
var text_button_st_css_1 = require("./text-button/text-button.st.css");
var close_button_st_css_1 = require("./close-button/close-button.st.css");
var theme_st_css_1 = require("./theme.st.css");
var opacity_st_css_1 = require("./opacity.st.css");
var border_st_css_1 = require("./border.st.css");
exports.opacity = opacity_st_css_1.default;
exports.border = border_st_css_1.default;
var getClassNames = function (values, stylesheet, rootcls) {
    var clsArray = values.map(function (cls) { return stylesheet[cls] || null; });
    return classNames(stylesheet[rootcls], clsArray);
};
exports.avatar = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return getClassNames(values, avatar_st_css_1.default, 'avatar');
};
exports.button = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return getClassNames(values, button_st_css_1.default, 'button');
};
exports.iconButton = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return getClassNames(values, icon_button_st_css_1.default, 'iconButton');
};
exports.textButton = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return getClassNames(values, text_button_st_css_1.default, 'textButton');
};
exports.closeButton = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return getClassNames(values, close_button_st_css_1.default, 'closeButton');
};
// FIX ME. I fail on yoshi test --protractor when used
// only with BackofficeTheme.root
exports.backofficeTheme = (theme_st_css_1.default && theme_st_css_1.default.root) || {};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/index.js
// module id = 1358
// module chunks = 0